import React, { useEffect, useState } from 'react';
import { subscribeToToasts } from '../lib/toast';

const TONES = {
  success: { bg: 'var(--accent)', fg: '#fff', icon: '✓' },
  warn: { bg: 'var(--amber)', fg: '#fff', icon: '!' },
  error: { bg: '#9b3a1f', fg: '#fff', icon: '×' },
};

// Mounted once at the app root. Subscribes to the toast pub/sub; renders
// whatever message was most recently shown, then auto-dismisses. Manual
// dismiss via the close button.
export default function Toast() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    let dismissTimer = null;
    const unsubscribe = subscribeToToasts((t) => {
      setToast(t);
      if (dismissTimer) clearTimeout(dismissTimer);
      dismissTimer = setTimeout(() => setToast(null), t.durationMs);
    });
    return () => {
      unsubscribe();
      if (dismissTimer) clearTimeout(dismissTimer);
    };
  }, []);

  if (!toast) return null;
  const tone = TONES[toast.tone] || TONES.success;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{ ...containerStyle, background: tone.bg, color: tone.fg }}
      data-tone={toast.tone}
    >
      <span style={iconStyle} aria-hidden="true">{tone.icon}</span>
      <span style={messageStyle}>{toast.message}</span>
      <button type="button" onClick={() => setToast(null)} style={closeStyle} aria-label="Dismiss">
        <svg width="12" height="12" viewBox="0 0 24 24">
          <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
}

const containerStyle = {
  position: 'fixed',
  bottom: '24px',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 200,
  display: 'inline-flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 18px',
  borderRadius: '999px',
  boxShadow: '0 10px 30px rgba(31, 26, 18, 0.18)',
  fontFamily: 'var(--font)',
  fontSize: '13.5px',
  fontWeight: 500,
  maxWidth: '90vw',
};

const iconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  background: 'rgba(255, 255, 255, 0.22)',
  fontWeight: 700,
  fontSize: '12px',
};

const messageStyle = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '60vw' };

const closeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  background: 'transparent',
  border: 'none',
  color: 'inherit',
  cursor: 'pointer',
  opacity: 0.85,
};
